import axios from "axios";
import useSWR from "swr";
import fetcher from "middleware/api";
import config from "../constants/config";

const getFetcher = (url) => axios.get(url).then((res) => res.data);

const baseUrl = config.baseUrl;
const KEYCLOAK = "KEYCLOAK";

export const useSWRGet = (path) => {
  if (!path) {
    throw new Error("Path is required");
  }

  const url = baseUrl + path;
  const { data: states, error, mutate } = useSWR(url, getFetcher);

  return { states, error, mutate };
};

export const useSWRPost = (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  // const url = baseUrl + path;
  const authenticated = true;
  const method = "post";
  const baseUrlPath = "";
  const response = useSWR([method, endpoint, authenticated, data, baseUrlPath], fetcher);

  return response;
};

export const useSWRRequest = (endpoint, data = null, baseUrlPath = "") => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  // const url = baseUrl + path;

  const response = useSWR(["get", endpoint, data, true, baseUrlPath], fetcher);

  return response;
};

export const useGet = async (endpoint, baseUrlPath) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "get";

  const response = await fetcher(method, endpoint, null, true, baseUrlPath);
  return response;
};

export const usePost = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "post";
  const { response } = await fetcher(method, endpoint, data);
  return response;
};

export const usePostKeycloak = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "post";
  const { response } = await fetcher(method, endpoint, data, true, KEYCLOAK);
  return response;
};

export const useDelete = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "delete";
  const { response } = await fetcher(method, endpoint, data);
  return response;
};

export const useDeleteKeycloak = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "delete";
  const { response } = await fetcher(method, endpoint, data, true, KEYCLOAK);
  return response;
};

export const usePut = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Endpoint is required");
  }

  try {
    const method = "put";
    const { response } = await fetcher(method, endpoint, data);

    return response;
  } catch (error) {
    return { error };
  }
};

export const usePutKeycloak = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "put";
  const { response } = await fetcher(method, endpoint, data, true, KEYCLOAK);
  return response;
};

export const usePatch = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "patch";
  const { response } = await fetcher(method, endpoint, data);
  return response;
};

export const useGetWithBaseUrl = async (endpoint, baseUrl) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  if (!baseUrl) {
    throw new Error("Base Url is required");
  }
  const method = "get";
  const response = await fetcher(method, endpoint, true, baseUrl);
  return response;
};
//withoutBearToken
export const useGetWithOutBearerToken = async (endpoint) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "get";
  const response = await fetcher(method, endpoint, false);
  return response;
};

export const usePostWithOutBearerToken = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "post";
  const { response } = await fetcher(method, endpoint, data, false);
  return response;
};

export const useDeleteWithOutBearerToken = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "delete";
  const { response } = await fetcher(method, endpoint, data, false);
  return response;
};

export const usePutWithOutBearerToken = async (endpoint, data) => {
  if (!endpoint) {
    throw new Error("Path is required");
  }
  const method = "put";
  const { response } = await fetcher(method, endpoint, data, false);
  return response;
};
